'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { AppointmentsLoading } from './appointments-loading.component';
import { AppointmentsTabs } from './appointments-tabs.component';

import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { useProtectedRoute } from '@/app/(main)/(pages)/_hooks/use-protected-route.hook';
import { getLogger } from '@/logger/logger';

const logger = getLogger('appointments.content');

export function AppointmentsContent() {
  const { isAuthReady, isLoggedIn } = useProtectedRoute();

  if (isAuthReady && !isLoggedIn) {
    logger.info('Blocked a signed-out visitor from a protected page', {
      auth: { event: 'protected_route_blocked', route: '/agendamentos' },
    });
    return null;
  }

  return (
    <>
      <Typography
        className="font-bold"
        data-testid={DataTestIdEnum.APPOINTMENTS_TITLE}
        variant={TypographyVariant.TITLE}
      >
        Agendamentos
      </Typography>
      {isAuthReady ? <AppointmentsTabs /> : <AppointmentsLoading />}
    </>
  );
}
